'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('forum-post-list', {
      url: '/forum/:cat',
      template: '<forum-post-list></forum-post-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/forum/list/post-list.routes.js